import * as S from "./UserInfoBox.style";
import { LoginType } from "@/common/states/user";
import { GuardianUser, StudentUser } from "@/common/types/user";
import { ReactComponent as IconUser } from "@/styles/assets/svg/icon_user.svg";
import { ReactComponent as IconLinked } from "@/styles/assets/svg/icon_user_linked.svg";

interface UserInfoProps {
  student: StudentUser | null;
  guardian: GuardianUser | null;
  loginType: LoginType;
}

export const UserInfoBox = ({
  student,
  guardian,
  loginType,
}: UserInfoProps) => {
  const studnetInfo = guardian?.student;
  return (
    <S.UserInfoBox>
      {/* 법정보호자 회원 정보 */}
      {loginType !== "student" && (
        <>
          <S.UserInfo>
            <S.UserInfoImg>
              <IconUser />
            </S.UserInfoImg>

            <S.UserTextBox>
              <S.UserTypeTxt>
                법정보호자 회원
                <span>UID {guardian?.id}</span>
              </S.UserTypeTxt>

              <S.UserNameTxt>{guardian?.name}</S.UserNameTxt>
            </S.UserTextBox>
          </S.UserInfo>

          {/* 법정보호자 회원일 경우 표기 */}
          <S.UserLinkedBox>
            <IconLinked />
          </S.UserLinkedBox>
        </>
      )}

      {/* 학생 회원 정보 */}
      {/* 
      1. STUDENT                        - <S.UserInfo> 보이기
      2. GUARDIAN ⬅️➡️ STUDENT         - <S.UserInfo> 보이기
      3. GUARDIAN ⬅️❌❌➡️ STUDENT    - <S.UserInfo> 안 보이기.
      */}
      {loginType === "student" ? (
        <S.UserInfo>
          <S.UserInfoImg>
            <IconUser />
          </S.UserInfoImg>

          <S.UserTextBox>
            <S.UserTypeTxt>
              {loginType === "student" ? "학생 회원" : "연동 학생 정보"}
              <span>
                UID{" "}
                {loginType === "student"
                  ? student?.studentCode
                  : studnetInfo?.studentCode}
              </span>
            </S.UserTypeTxt>

            <S.UserNameTxt>
              {loginType === "student" ? (
                <>
                  {student?.name}
                  <span> {student?.schoolName}</span>
                </>
              ) : studnetInfo ? (
                <>
                  {studnetInfo?.name}
                  <span> {studnetInfo?.school?.name}</span>
                </>
              ) : (
                "학생 정보가 없습니다"
              )}
            </S.UserNameTxt>
          </S.UserTextBox>
        </S.UserInfo>
      ) : (
        studnetInfo && (
          <S.UserInfo>
            <S.UserInfoImg>
              <IconUser />
            </S.UserInfoImg>

            <S.UserTextBox>
              <S.UserTypeTxt>
                연동 학생 정보
                <span>UID {studnetInfo?.studentCode}</span>
              </S.UserTypeTxt>

              <S.UserNameTxt>
                {studnetInfo?.name}
                <span> {studnetInfo?.school?.name}</span>
              </S.UserNameTxt>
            </S.UserTextBox>
          </S.UserInfo>
        )
      )}
    </S.UserInfoBox>
  );
};
